export function publicMailRoute(href:string):'reminder'|'unsubscribe'|'verification'|null{
 const u=new URL(href);
 if(u.pathname==='/'&&u.searchParams.getAll('resend-verification').length===1&&u.searchParams.get('resend-verification')==='1')return 'verification';
 if(['/unsubscribe','/unsubscribe/','/unsubscribe.html'].includes(u.pathname))return 'unsubscribe';
 if(u.pathname==='/'&&u.searchParams.getAll('confirm-reminder').length===1&&u.searchParams.get('confirm-reminder')==='1')return 'reminder';
 return null;
}
